export const toNumber = (value) => {
  if (value === null || value === undefined) return Number.NaN;
  if (typeof value === 'number') return value;
  return parseFloat(String(value).replace(',', '.'));
};

export const toFixedString = (value, decimals = 2) => {
  const num = typeof value === 'number' ? value : toNumber(value);
  return Number.isNaN(num) ? '' : num.toFixed(decimals);
};

export const toCommaString = (value, decimals = 2) => {
  const fixed = toFixedString(value, decimals);
  return fixed ? fixed.replace('.', ',') : '';
};

export const calculateImc = ({ peso, tallaCm, asComma = false }) => {
  const pesoNum = toNumber(peso);
  const tallaNum = toNumber(tallaCm);

  if (Number.isNaN(pesoNum) || Number.isNaN(tallaNum) || pesoNum <= 0 || tallaNum <= 0) return '';

  const tallaM = tallaNum / 100;
  const imc = pesoNum / (tallaM * tallaM);
  return asComma ? toCommaString(imc, 2) : toFixedString(imc, 2);
};

export const calculatePerimetroMedio = ({ p1, p2, p3, asComma = false }) => {
  const n1 = toNumber(p1);
  const n2 = toNumber(p2);
  const n3 = toNumber(p3);

  if ([n1, n2, n3].some((n) => Number.isNaN(n) || n <= 0)) return '';

  const media = (n1 + n2 + n3) / 3;
  return asComma ? toCommaString(media, 1) : toFixedString(media, 1);
};

export const calculatePesoBrazosPiernas = ({ bd, bi, pd, pi, asComma = false }) => {
  const values = [bd, bi, pd, pi].map(toNumber).map((n) => (Number.isNaN(n) ? 0 : n));
  const total = values.reduce((sum, n) => sum + n, 0);
  return asComma ? toCommaString(total, 2) : toFixedString(total, 2);
};

export const calculateSmi = ({ bd, bi, pd, pi, tallaCm, asComma = false }) => {
  const tallaNum = toNumber(tallaCm);
  const values = [bd, bi, pd, pi].map(toNumber);

  if (Number.isNaN(tallaNum) || tallaNum <= 0) return '';
  if (values.some((n) => Number.isNaN(n) || n <= 0)) return '';

  const tallaM = tallaNum / 100;
  const smi = values.reduce((sum, n) => sum + n, 0) / (tallaM * tallaM);
  return asComma ? toCommaString(smi, 2) : toFixedString(smi, 2);
};
